export default __webpack_public_path__ + "static/media/user-icon.73f00609.svg";